export const NAME_REGEX =
  /^[a-zA-ZÀÁÂÃÄÅàáâãäåÒÓÔÕÖØòóôõöøÈÉÊËèéêëÇçÌÍÎÏìíîïÙÚÛÜùúûüÿÑñ \-']{2,40}$/;

export const validateName = (value: string) =>
  new RegExp(NAME_REGEX).test(value);
